export default __webpack_public_path__ + "static/home_service_2-60887a9e44456cd7ade1e3b64132f451.jpg";